import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';

@Component({
	selector: 'xp-paginator',
	standalone: true,
	imports: [MatPaginatorModule],
	templateUrl: './xp-paginator.component.html',
	styleUrls: ['./xp-paginator.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpPaginatorComponent {
	length = input(0);
	pageIndex = input(0);
	pageSize = input(0);
	pageSizeOptions = input<number[]>([]);
	hidePageSize = input(false);
	showFirstLastButtons = input(false);
	ariaLabel = input<string | null>(null);
	page = output<PageEvent>();
}
